import React, { useContext, useMemo, useState } from 'react';
import { css } from '@emotion/react';
import { Tab, Tabs } from '@material-ui/core';
import { UserContext } from '@/components/App';
import { useClientUser } from '@/hooks';
import Stores from '@/components/Account/ShipperAccount/Stores';
import SKUsAndServices from '@/components/Account/SKUsAndServices';
import SLARequirements from '@/components/Account/SLARequirements';
import Teammates from '@/components/Account/Teammates';
import Surveys from '@/components/Account/Surveys';
import Communications from '@/components/Account/Communications';
import { shipperCommsFor } from '@/components/Account/ShipperAccount/comms';
import useTariffBundle from '@/components/Account/hooks/useTariffBundle';
import { AccentBar, Card, Section, SectionHeader, SectionTitle } from '../blocks';
import { OPERATIONAL_TABS } from '../constants';

// One panel per OPERATIONAL_TABS key. Each is the Account component, resolving the shipper from
// the overridden UserContext.
const PANELS = {
    stores: ({ client }) => <Stores currentClient={client} bare />,
    skus: ({ client_id }) => <SKUsAndServices clientRef={client_id} />,
    sla: () => <SLARequirements />,
    teammates: ({ tariffBundle }) => (
        <Teammates
            teamLeaderType="shipper"
            tariffs={tariffBundle.tariffs}
            driverMappings={tariffBundle.driverMappings}
            callbacks={tariffBundle.callbacks}
        />
    ),
    surveys: () => <Surveys />,
    communication: ({ comms }) => <Communications comms={comms} />,
};

const Operational = () => {
    const { client } = useContext(UserContext);
    const { client_id, partner_carriers } = useClientUser();
    // Communications takes the toggle *definitions*; the values come off users.circles, which it
    // reads from context itself. Passing circles here is what crashed it.
    const comms = useMemo(() => shipperCommsFor({ partnerCarriers: partner_carriers }), [partner_carriers]);
    const tariffBundle = useTariffBundle();
    const [tab, setTab] = useState(0);
    const Panel = PANELS[OPERATIONAL_TABS[tab].key];

    return (
        <Section>
            <SectionHeader>
                <AccentBar />
                <SectionTitle>Operational self-service</SectionTitle>
            </SectionHeader>
            <Card>
                <Tabs
                    value={tab}
                    onChange={(_, next) => setTab(next)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    css={css`
                        border-bottom: 1px solid #e2e2e2;
                    `}
                >
                    {OPERATIONAL_TABS.map((t) => (
                        <Tab key={t.key} label={t.label} />
                    ))}
                </Tabs>
                <div
                    css={css`
                        padding: 1.5rem;
                    `}
                >
                    <Panel client={client} client_id={client_id} comms={comms} tariffBundle={tariffBundle} />
                </div>
            </Card>
        </Section>
    );
};

export default Operational;
